module.exports = __webpack_public_path__ + "img/detail4.5d7082f9.png";